import React, { useState, useEffect, useRef } from "react";
import CarouselItem from "./CarouselItem";
import CarouselMiniature from "./CarouselMiniature";

export default function CarouselList({
  gallery,
  bar,
  toFullScren,
  fullscreen,
  autoChange
}) {
  const [queue, setQueue] = useState(0);
  const [key, setKey] = useState(0); // Agregamos una clave única para forzar el re-renderizado
  const carouselRef = useRef(null);

  useEffect(() => {
    if (autoChange) {
      const timer = setTimeout(() => {
        if (queue === gallery.length - 1) {
          setQueue(0);
        } else {
          setQueue(queue + 1);
        }
        setKey((prevKey) => prevKey + 1); // Cambiamos la clave única para forzar el re-renderizado
      }, 8000);

      // Limpiar el temporizador para evitar fugas de memoria
      return () => clearTimeout(timer);
    }
  }, [queue, gallery, autoChange]); // Dependencias añadidas: queue, gallery y autoChange

  const next = () => {
    if (carouselRef.current) {
      carouselRef.current.scrollBy({
        left: carouselRef.current.clientWidth, // Desplaza por el ancho del carrusel visible
        behavior: 'smooth' // Desplazamiento suave
      });
    }
  };

  const previous = () => {
    if (carouselRef.current) {
      carouselRef.current.scrollBy({
        left: -carouselRef.current.clientWidth, // Desplaza por el ancho del carrusel visible
        behavior: 'smooth' // Desplazamiento suave
      });
    }
  };

  const [openMiniatures, setOpenMiniatures] = useState(false);

  const openMiniaturesF = () => {
    setOpenMiniatures(!openMiniatures);
  };

  const chooseImg = (a) => {
    setQueue(a);
    setKey((prevKey) => prevKey + 1);
  };

  return (
    <div className="carousel-list-container">
      <div ref={carouselRef} className="carousel-list">
        {gallery.map((e, index) => (
          <CarouselItem {...e} key={index} fullscreen={fullscreen} />
        ))}
      </div>

      <div className={`carousel-buttons-cont ${fullscreen ? "fullscreen-to-top" : ""}`}>
        <button onClick={previous} className="carousel-button">
          ‹
        </button>
        <button onClick={next} className="carousel-button">
          ›
        </button>
      </div>
    </div>
  );
}
